/**
 * Detects difference of two objects
 * @param {Object} obj1
 * @param {Object} obj2
 * @returns {Object} object containing differences
 */
export const objectDiff = (obj1, obj2) => {
  return Object.keys(obj2).reduce((diff, key) => {
    if (obj1[key] === obj2[key]) return diff
    return {
      ...diff,
      [key]: obj2[key],
    }
  }, {})
}

export const filterUnique2dArray = array => {
  const set = new Set(array.map(JSON.stringify))
  return [...set].map(JSON.parse)
}
